import { Slider } from 'antd'
import dayjs from 'dayjs'

export default function Axis({ start, end, value, onChange }: { start: string; end: string; value: [string, string]; onChange: (range: [string, string]) => void }) {
  const days = Math.max(1, dayjs(end).diff(dayjs(start), 'day'))
  return <div className="pl-[120px] pr-5" aria-label="总览日期范围">
    <Slider range min={0} max={days} value={value.map(d => dayjs(d).diff(dayjs(start), 'day')) as [number, number]} tooltip={{ formatter: v => dayjs(start).add(v || 0, 'day').format('YYYY-MM-DD') }} onChange={v => { const sorted = [...v].sort((a, b) => a - b); onChange([dayjs(start).add(sorted[0], 'day').format('YYYY-MM-DD'), dayjs(start).add(sorted[1], 'day').format('YYYY-MM-DD')]) }} />
    <div className="flex justify-between text-xs text-gray-500"><span>{start}</span><span>{end}</span></div>
  </div>
}
